import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import TextInput from '../inputs/TextInput';
import Button from '../buttons/Button';
import ErrorMessage from '../message/ErrorMessage';
import { postDivisionUsingDivisionid } from '../../api/cloudApiGenerated';

class EditDivisionModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.saveDivision = this.saveDivision.bind(this);
    this.getDivision = this.getDivision.bind(this);
    this.deleteDivision = this.deleteDivision.bind(this);

    this.state = {
      name: '',
      selectValue: '0',
      division: {
        name: '',
      },
    };
  }

  componentDidMount() {
    if (this.props.activeDivision) {
      this.getDivision(this.props.activeDivision);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.activeDivision !== this.props.activeDivision) {
      this.getDivision(this.props.activeDivision);
    }
  }

  onSearchInputChange(event) {
    let division = this.state.division;
    division.name = event.target.value;
    this.setState({
      division,
    });
  }

  getDivision(id) {
    if (this.props.divisions && id) {
      let division = this.props.divisions.find((x) => x.id === parseInt(id));
      this.setState({
        division: Object.assign({}, division),
      });
    }
  }

  onChange(element) {
    this.setState({ selectValue: element });
  }

  saveDivision(element) {
    let data = {
      name: this.state.division.name,
    };

    postDivisionUsingDivisionid(parseInt(this.props.activeDivision), data)
      .then((data) => {
        let division = this.props.divisions.find((x) => x.id === parseInt(this.state.division.id));
        division.name = this.state.division.name;

        this.props.refreshDivisions();
        this.props.close();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  deleteDivision(element) {
    let data = {
      deleted: true,
    };

    postDivisionUsingDivisionid(parseInt(this.props.activeDivision), data)
      .then((data) => {
        this.props.selectDefault();
        this.props.close();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    return (
      <Modal
        className="hc-modal-content"
        appElement={document.querySelector('.page-container')}
        overlayClassName="hc-modal-overlay"
        parentSelector={this.props.parentSelector}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.close}
        contentLabel="New Team"
      >
        <h3> Edit Subteam </h3>
        <div>
          <label htmlFor="name"> Name: </label>
        </div>
        <TextInput
          name="name"
          value={this.state.division && this.state.division.name}
          onChange={this.onSearchInputChange}
          placeholder="Name"
          autoFocus={true}
        />
        <br />
        <Button buttonText="Save" extraClass="bulk-action-btn small" onClick={this.saveDivision} />{' '}
        <Button buttonText="Cancel" extraClass="bulk-action-btn grey small" onClick={this.props.close} />{' '}
        <Button
          buttonText="Delete"
          buttonClass="bulk-action-btn small danger pull-right"
          onClick={this.deleteDivision}
        />
      </Modal>
    );
  }
}

EditDivisionModal.propTypes = {
  isOpen: PropTypes.bool,
  parentSelector: PropTypes.func,
  close: PropTypes.func,
  reloadDivisions: PropTypes.func,
  team: PropTypes.object,
  activeDivision: PropTypes.string,
  divisions: PropTypes.array,
  refreshDivisions: PropTypes.func,
  selectDefault: PropTypes.func,
};

export default EditDivisionModal;
